import { actionsStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderActions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

actionsStyles.addAllToCartButton = {
    variant: "primary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-top: 10px;
                `,
                css`
                    margin-left: 10px;
                    padding: 0 14px;
                `,
                css`
                    margin-left: 10px;
                `,
                css`
                    margin-left: 10px;
                `,
            ])}
    `,
};
